import { FC } from 'react';
import { Divider, Form, Table } from 'antd';
import { useForm } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import { OfficeObservationCompetitor } from '@/libs/fleet-api/services/types';
import { useFBDHVisitReportApprovalPage } from './VisitReportApproval';

type VisitReportCompetitorForm = {
	lists: OfficeObservationCompetitor[];
};

const FBDHVisitReportCompetitor: FC = () => {
	const { officeObservation } = useFBDHVisitReportApprovalPage();
	const { marketingAspect } = officeObservation ?? {};
	const { form, fieldName } = useForm<VisitReportCompetitorForm>();

	return (
		<Form.Provider>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				initialValues={
					{
						lists: marketingAspect?.competitors ?? [],
					} as VisitReportCompetitorForm
				}
				style={{ marginBottom: 30 }}
			>
				<Form.Item
					name={fieldName(['lists'])}
					noStyle
				/>
				<Form.Item shouldUpdate>
					{({ getFieldsValue }) => {
						const values = getFieldsValue() as VisitReportCompetitorForm;
						const dataSource =
							values?.lists?.map((list, key?) => {
								return { ...list, key };
							}) ?? [];

						return (
							<Table
								bordered
								pagination={false}
								dataSource={dataSource}
								columns={[
									{
										title: 'No',
										render: (_, __, index) => index + 1,
										width: 1,
										align: 'center',
									},
									{
										title: 'Kompetitor',
										render: (_, record) => record.name ?? '-',
									},
								]}
							/>
						);
					}}
				</Form.Item>
			</Form>
			<Divider />
		</Form.Provider>
	);
};

export default FBDHVisitReportCompetitor;
